<template>
  <div id="app">
    <router-view v-if="isRouterAlive"/>
  </div>
</template>

<script>

import { modifyNetTitle } from "@/common/js/utils";
import { saveTwolevelAuthrity } from "@/common/js/storage";
import Administrator from "@/models/administrator.js";
export default {
  provide() {
    return {
      reload: this.reload
    }
  },
  data() {
    return {
      isRouterAlive: true
    }
  },

  mounted() {
    let logoUrl = require('./assets/fire-logo.png') 
    modifyNetTitle(logoUrl)
    this.initTwolevelAuthority()
  },
  methods: {
    initTwolevelAuthority() {
      Administrator.getTwolevelAuthority().then(res => {
        if (res.success) {
          saveTwolevelAuthrity(res.result);
        } else {
          this.$message.error(res.message)
        }
      })
    },
    /* 页面刷新 */
    reload() {
      this.isRouterAlive = false
      this.$nextTick(() => {
        this.isRouterAlive = true
      })
    }
  }
}
</script>


<style lang="scss">
@import './common/style/common.scss';
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
